import { Component } from '@angular/core';
import { TitleService } from '../../../services/title.service';

@Component({
    selector: 'app-personal-training',
    imports: [],
    templateUrl: './personal-training.component.html',
    styleUrl: './personal-training.component.css'
})
export class PersonalTrainingComponent {
  constructor(private ts : TitleService) {  }

  ngOnInit(){
    this.ts.titolo = "Personal Training";
  }
}
